"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrUpdateWithBufferV1 = exports.PUFF_CHUNK_SIZE = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const generated_1 = require("./generated");
const revisions_1 = require("./revisions");
const writeRuleSetToBufferV1_1 = require("./writeRuleSetToBufferV1");
exports.PUFF_CHUNK_SIZE = 10000;
const createOrUpdateWithBufferV1 = (context, input) => {
    const payer = input.payer ?? context.payer;
    const chunkSize = input.chunkSize ?? 900;
    const bufferPda = (0, generated_1.findRuleSetBufferPda)(context, { owner: payer.publicKey });
    const ruleSetPda = (0, generated_1.findRuleSetPda)(context, {
        owner: payer.publicKey,
        name: input.ruleSetName,
    });
    const serializedRevision = (0, revisions_1.getRuleSetRevisionSerializer)().serialize(input.ruleSetRevision);
    // Write instructions.
    const writeInstructions = (0, writeRuleSetToBufferV1_1.writeRuleSetToBufferV1)(context, {
        payer,
        ruleSetRevision: input.ruleSetRevision,
        chunkSize,
    }).merge();
    // Puff instructions.
    const puffSize = serializedRevision.length;
    const numberOfPuffs = Math.ceil(puffSize / exports.PUFF_CHUNK_SIZE) - 1;
    const puffInstructions = Array.from({ length: numberOfPuffs }, () => (0, generated_1.puffRuleSetV1)(context, {
        payer,
        ruleSetPda,
        ruleSetName: input.ruleSetName,
    }));
    // Create or update from buffer.
    const builder = (0, umi_1.transactionBuilder)()
        .add(writeInstructions)
        .add(puffInstructions)
        .add((0, generated_1.createOrUpdateV1)(context, {
        payer,
        ruleSetPda,
        bufferPda,
        ruleSetRevision: (0, umi_1.none)(),
    }));
    return (0, umi_1.transactionBuilderGroup)(builder.unsafeSplitByTransactionSize(context)).sequential();
};
exports.createOrUpdateWithBufferV1 = createOrUpdateWithBufferV1;
//# sourceMappingURL=createOrUpdateWithBufferV1.js.map